import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import "../styles/faq.css";

export default function Faq({ categories, defaultCategory }) {
  const [activeKey, setActiveKey] = useState(
    defaultCategory || categories[0]?.key
  );
  const [openIndex, setOpenIndex] = useState(-1);

  const activeCategory =
    categories.find((cat) => cat.key === activeKey) || categories[0];

  const handleSelectCategory = (key) => {
    setActiveKey(key);
    setOpenIndex(-1);
  };

  return (
    <div className="faq-block">
      <div className="faq-sidebar">
        {categories.map((cat) => (
          <button
            key={cat.key}
            type="button"
            className={`faq-sidebar-item${
              cat.key === activeCategory.key ? " active" : ""
            }`}
            onClick={() => handleSelectCategory(cat.key)}
          >
            {cat.label}
          </button>
        ))}
      </div>

      <div className="faq-content">
        <div className="faq-content-header">
          <h3>{activeCategory.label} kérdések</h3>
        </div>

        <div className="faq-list">
          {activeCategory.items.map((item, index) => {
            const isOpen = index === openIndex;
            return (
              <div
                key={item.question}
                className={`faq-item${isOpen ? " open" : ""}`}
              >
                <button
                  type="button"
                  className="faq-item-header"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                >
                  <span className="faq-question">{item.question}</span>
                  <span className="faq-toggle">
                    <FontAwesomeIcon icon={faPlus} />
                  </span>
                </button>
                <div className="faq-answer-wrapper">
                  <div className="faq-answer-inner">
                    <div className="faq-answer">{item.answer}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
